const NAME = 'partner'

const getPartner = () => {
    return localStorage.getItem(NAME)
}
const setPartner = (partnerId) => {
    localStorage.setItem(NAME, partnerId)
}

export {getPartner, setPartner}
